module.exports = __webpack_public_path__ + "img/creative-tim.d89e3df9.svg";